import { FC, ReactNode } from 'react';
import { Col } from 'antd';
import {
  ButtonRow,
  CancelButton,
  Description,
  DescriptionRow,
  ConfirmButton,
} from './styled';
import BaseModal, { BaseModalProps } from '../BaseModal';

export interface BaseConfirmationModalProps extends BaseModalProps {
  description?: string | ReactNode;
  confirmText?: string;
  hideSubmitButton?: boolean;
  hideCancelButton?: boolean;
  onConfirm?(): void;
}

const BaseConfirmationModal: FC<BaseConfirmationModalProps> = ({
  description,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  hideSubmitButton = false,
  hideCancelButton = false,
  onConfirm = () => {},
  children,
  ...props
}) => (
  <BaseModal {...props}>
    {description && (
      <DescriptionRow className="description" align="middle" justify="center">
        <Col span={24}>
          <Description>{description}</Description>
        </Col>
      </DescriptionRow>
    )}

    {children}

    <ButtonRow className="button-row" gutter={16}>
      {!hideCancelButton && (
        <Col span={hideSubmitButton ? 24 : 12}>
          <CancelButton onClick={props.onCancel} block>
            {cancelText}
          </CancelButton>
        </Col>
      )}
      {!hideSubmitButton && (
        <Col span={hideCancelButton ? 24 : 12}>
          <ConfirmButton
            type="primary"
            onClick={onConfirm}
            loading={props.confirmLoading}
            block
          >
            {confirmText}
          </ConfirmButton>
        </Col>
      )}
    </ButtonRow>
  </BaseModal>
);

export default BaseConfirmationModal;
